import React, { Component } from 'react';
import $ from "jquery";
import Cookies from "js-cookie";
import ReCAPTCHA from "react-google-recaptcha";
//import 'popper.js/dist/popper.min.js';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import 'bootstrap/dist/css/bootstrap.min.css';
//import 'bootstrap/dist/css/bootstrap-grid.min.css';
import './App.css';

var version = "ver.1.0";
var n_banner = 1;

const _reset =
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-x-lg" viewBox="0 0 16 16">
    <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8 2.146 2.854Z"/>
  </svg>

class App extends Component {

  constructor(props, context) {

    super(props, context);

    let mobile = window.screen.width < 768 ? true : false;

    this.state = {
      mobile:mobile,
      pagina:'glossario',
      lemma:false,
      categoria:'0',
      filtro:'',
      bookmarks:false,
      cookie_bookmarks:[],
      news:window.db_news,
      lemmi:window.db_lemmi,
      pillole:window.db_pillole,
      categorie:window.db_categorie,
      approfondimenti:window.db_approfondimenti,
      id_from_get:this.props.id_from_get
    };
  }

  componentDidMount() {

    this.setState({ om_lemmi_disponibili: window.db_lemmi.length });
    this.setState({ om_lemmi_futuri: window.lemmi_futuri });
    this.setState({ om_prox_agg: window.giorno_prossimo_aggiornamento });

    this.initBookmarksFromCookie(this.state.lemmi)

    $('#modal_approfondimento').on('hidden.bs.modal', function (e) {
      this.setState({video:""})
      //document.getElementById("video_approfondimento").pause();
    }.bind(this))

    var bt = setInterval(bannerTimer, 7000);

    if (!isNaN(this.state.id_from_get)) {
      this.showLemma(this.state.id_from_get)
    }

  }

  initBookmarksFromCookie = (lemmi) => {

    //Cookies.remove('bookmarks', { path: '/' }); //pulizia x test

    if (typeof (Cookies.get('bookmarks')) !== 'undefined') {

      let cookie_bookmarks = []
      cookie_bookmarks = JSON.parse(Cookies.get('bookmarks'))
      for (let ii=0; ii<cookie_bookmarks.length; ii++) {
        if (cookie_bookmarks[ii]===null) continue
        for (let jj=0; jj<lemmi.length; jj++)
          if (lemmi[jj].id===cookie_bookmarks[ii].id) lemmi[jj].bookmark = cookie_bookmarks[ii].bookmark
      }
      this.setState({lemmi:lemmi, cookie_bookmarks:cookie_bookmarks})
    }
  }

  changeCategoria = (e) => {
    this.setState({categoria: e.target.value});
  }

  /*
  filterBookmarks = (e) => {
    this.setState({bookmarks: !this.state.bookmarks});
  }
  */

  filterLemma = (e) => {
    this.setState({filtro: e.target.value});
  }

  resetLemma = () => {
    $('#in-lemma').val('');
    this.setState({filtro: ''});
  }

  showGlossario = () => {

    this.hideLemma();
    this.setState({pagina:'glossario', filtro:'', categoria:'0'});

  }

  showLemmaFromNews = (id) => {
    this.setState({pagina: "glossario"});
    setTimeout(function(){ this.showLemma(id); }.bind(this), 500); //devo dare il tempo a react di creare il DOM altrimenti scrollTop non trova il div
  }

  showLemma = (id) => {

    $('.lemma').removeClass('lemma-sel');
    $('#lemma-'+id).addClass('lemma-sel');
    //$('#div-lemmi').animate({scrollTop: $('#lemma-'+id).offset().top-280},'slow');

    let lemma = this.state.lemmi.filter(function(d) { return d.id===id; });
    this.setState({lemma: lemma[0]});

		if (this.state.mobile) $('html,body').animate({scrollTop: $("#div-scheda").offset().top-110},'slow');

    $.ajax({
      url: "_services/dispatch.php",
      type: "POST",
      cache: false,
      data: {azione:'hitLemmi', id:lemma[0].id},
      success: function(data) {},
      error: function(xhr, status, err) {},
    });

  }

  hideLemma = () => {
    this.setState({lemma: false});
    if (this.state.mobile) $('html,body').animate({scrollTop: 0},'slow');
  }

  hideSplash = () => {
    $('#splash').fadeOut(1000, function(){$('#app').fadeIn(1000)} )
  }

  bookmark = (id) => {
    let lemmi = this.state.lemmi;
    let bookmarks = this.state.cookie_bookmarks; //JSON.parse(Cookies.get('bookmarks'));
    for (let ii=0; ii<lemmi.length; ii++)
      if (lemmi[ii].id===id) {
        lemmi[ii].bookmark = lemmi[ii].bookmark=='0'?'1':'0';
        bookmarks[ii] = {"id":lemmi[ii].id,"bookmark":lemmi[ii].bookmark};
        this.setState({lemmi: lemmi, cookie_bookmarks: bookmarks});
        Cookies.set('bookmarks', JSON.stringify(bookmarks), { expires: 365 });
        break;
      }
  }

  showPillola = (id) => {
    $('#modal_pillola').modal('show')
    let pillola = this.state.pillole.filter(function(d) { return d.id===id; });
    this.setState({nome_pillola:pillola[0].nome, testo_pillola:pillola[0].testo})
  }

  showApprofondimento = (id) => {
    let approfondimenti = this.state.approfondimenti.filter(function(d) { return d.id===id; });
    //let src_video = <source src={approfondimenti[0].url} type="video/mp4" />
    //this.setState({src_video:src_video, nome_approfondimento:approfondimenti[0].nome, slides:approfondimenti[0].slides})
    let video = <video id="video_approfondimento" className="embed-responsive-item" controls><source src={approfondimenti[0].url} type="video/mp4" /></video>
    this.setState({video:video, nome_approfondimento:approfondimenti[0].nome, slides:approfondimenti[0].slides})
    $('#modal_approfondimento').modal('show')
  }

  render() {

    let lemmi = this.state.lemmi;

    if (this.state.bookmarks) lemmi = lemmi.filter(function(d) {return (d.bookmark==='1') });

    lemmi = lemmi.filter(function(d) {return (d.id_categoria===this.state.categoria)||this.state.categoria==='0'; }.bind(this));

    let filtro = this.state.filtro.toLowerCase();
    lemmi = lemmi.filter(function(d) { return d.nome.toLowerCase().indexOf(filtro)!==-1; });

    let html_lemmi = [];

    if (this.state.lemmi) html_lemmi = lemmi.map(d => <div id={'lemma-'+d.id} className="lemma" key={d.id}><a href="#" onClick={()=> this.showLemma(d.id)}><div dangerouslySetInnerHTML={createMarkup(d.nome)} /></a></div>);

    let select_categorie = '';
    if (this.state.categorie) select_categorie = this.state.categorie.map(d => <option key={d.id} value={d.id}>{d.nome}</option>);

    let menu_pillole = '';
    if (this.state.pillole) menu_pillole = this.state.pillole.map(d => <a key={'p'+d.id} className="dropdown-item" href="#" onClick={()=>this.showPillola(d.id)}>{d.nome}</a>);

    let html_approfondimenti_pubblicati = [];
    let html_approfondimenti_da_pubblicare = [];
    if (this.state.approfondimenti) {
      let appr = this.state.approfondimenti;
      for (let ii=0; ii<appr.length; ii++) {
        if (appr[ii].url)
          html_approfondimenti_pubblicati[ii] =
            <tr key={ii}>
              <td><i>{appr[ii].data}</i><br /><b>{appr[ii].nome}</b><br />{appr[ii].autore}</td>
              <td><a className="btn btn-primary" href="#" onClick={()=>this.showApprofondimento(appr[ii].id)}>Vedi video</a></td>
              <td><a className="btn btn-primary" href={"media/"+appr[ii].slides} target="_blank">Scarica slides</a></td>
            </tr>
        else
          html_approfondimenti_da_pubblicare[ii] = <tr key={ii}><td><b>{appr[ii].nome}</b><br />{appr[ii].autore}</td></tr>
      }
    }

    let news = this.state.news;

    let scheda_sopra = <div className="scheda"><div className="row"><div className="col-12"></div></div></div>
    let scheda_sotto = <div className="scheda"><div className="row"><div className="col-12"></div></div></div>

    if (this.state.lemma) {
      let links = [];
      let vedi_anche = '';
      if (this.state.lemma.link) {

        let l = this.state.lemma.link.split(',');
        for (let ii=0; ii<l.length; ii++) {
          let lemma = this.state.lemmi.filter(function(d) { return d.id===l[ii]; });
          links[ii] = <div key={ii}><a className="a-strong" href="#" onClick={()=>this.showLemma(lemma[0].id)}><div dangerouslySetInnerHTML={createMarkup(lemma[0].nome)} /></a></div>
        }

        vedi_anche =
          <div className="row">
            <div className="col-12 vedi">
            <strong>Vedi anche</strong><br />
            {links}
            </div>
          </div>

      }

      let sinonimi = '';
      if (this.state.lemma.sinonimi) {
        sinonimi =
          <div className="row">
            <div className="col-12 sinonimi">
              <div className="bold">Sinonimi</div>
              <div dangerouslySetInnerHTML={createMarkup(this.state.lemma.sinonimi)} />
            </div>
          </div>
      }

      let pillole = '';
      let pillole_lemma = this.state.pillole.filter(function(d) {return (d.id_lemma===this.state.lemma.id) }.bind(this));
      if (pillole_lemma.length) {
        let html_pillole = [];
        for (let ii=0; ii<pillole_lemma.length; ii++) {
          html_pillole[ii] = <div key={ii}><a className="a-strong" href="#" onClick={()=>this.showPillola(pillole_lemma[ii].id)}>{pillole_lemma[ii].nome}</a></div>
        }
        pillole =
          <div className="row">
            <div className="col-12 vedi">
            <strong>Pillole</strong><br />
            {html_pillole}
            </div>
          </div>
      }

      let approfondimenti = '';
      let approfondimenti_lemma = this.state.approfondimenti.filter(function(d) {return (d.id_lemma===this.state.lemma.id) }.bind(this));
      if (approfondimenti_lemma.length) {
        let html_approfondimenti = [];
        for (let ii=0; ii<approfondimenti_lemma.length; ii++) {
          html_approfondimenti[ii] = <div key={ii}><a className="a-strong" href="#" onClick={()=>this.showApprofondimento(approfondimenti_lemma[ii].id)}>{approfondimenti_lemma[ii].nome}</a></div>
        }
        approfondimenti =
          <div className="row">
            <div className="col-12 vedi">
            <strong>Approfondimenti</strong><br />
            {html_approfondimenti}
            </div>
          </div>
      }

      //rimando ad altro lemma
      let descrizione = this.state.lemma.descrizione
      let spiegazione = <div dangerouslySetInnerHTML={createMarkup(descrizione)} />
      if (!isNaN(descrizione)) {
        let lemma = this.state.lemmi.filter(function(d) { return d.id===descrizione; });
        let nome_lemma = <span dangerouslySetInnerHTML={createMarkup(lemma[0].nome)} />
        spiegazione = <div>Vedi <a href="#" onClick={()=>this.showLemma(lemma[0].id)}>{nome_lemma}</a></div>
      }

      //creo link diretto
      let href = window.location.href.split("?");
      let url = href[0].replace("#", "")
      let link_lemma = url+"?"+this.state.lemma.id

      let menu_lemma =
        <div className="row">
          <div className="col-9 nome">
            <div dangerouslySetInnerHTML={createMarkup(this.state.lemma.nome)} />
          </div>
          <div className="col-1 nome">
            <a className="link" onClick={()=>{navigator.clipboard.writeText(link_lemma); $('#toast').toast('show');}}><img src="img/copialink.svg" width="20px" alt="link" title="copia il link"  /></a>
          </div>
          <div className="col-1 nome text-center">
            <a className="link" onClick={()=>stampaScheda()}><img src="img/stampa.svg" width="20px" alt="stampa" title="stampa" /></a>
          </div>
          <div className="col-1 nome text-center">
            <a className="link" onClick={this.hideLemma}><img src="img/chiudi.svg" width="20px" alt="chiudi" title="chiudi" /></a>
          </div>
        </div>

      if (this.state.mobile) {
        menu_lemma =
          <div className="row">
            <div className="col-12 nome">
              <div dangerouslySetInnerHTML={createMarkup(this.state.lemma.nome)} />
            </div>
            {/*
            <div className="col-2 nome text-center">
              <a className="link" onClick={this.hideLemma}><img src="img/chiudi.svg" width="20px" alt="C" title="chiudi" /></a>
            </div>
            */}
          </div>
      }

      scheda_sopra =
        <div className="scheda">

      <div className="toast-container" aria-live="polite" aria-atomic="true">
        <div id="toast" className="toast hide my-toast" role="alert" aria-live="assertive" aria-atomic="true" data-delay="2000">
          <div className="toast-header">Link copiato!</div>
        </div>
      </div>

          <div id="lemma">
            {menu_lemma}
            {sinonimi}
            <div className="row">
              <div className="col-12 spiega">
                {spiegazione}
              </div>
            </div>
          </div>
        </div>

      scheda_sotto =
        <div className="scheda">
          {vedi_anche}
          {pillole}
          {approfondimenti}
        </div>
    }

    let pagina = '';

    //let banner = this.state.mobile ? <img src="img/banner_mobile.svg" /> : <img src="img/banner_1.svg" />;

    //preload di tutti i banner (evito lag immagini al primo giro)
    let banner =
      <div className="banner">
        <div id="banner">
          <img src="img/banner-1.svg" />
          <img src="img/banner-2.svg" style={{display:"none"}} />
          <img src="img/banner-3.svg" style={{display:"none"}} />
        </div>
      </div>

    if (this.state.mobile)
      banner =
        <div className="banner">
          <div id="banner">
            <img src="img/banner-1-mobile.svg" />
            <img src="img/banner-2-mobile.svg" style={{display:"none"}} />
            <img src="img/banner-3-mobile.svg" style={{display:"none"}} />
          </div>
        </div>


    if (this.state.pagina==="home")
      pagina =
        <div>

          <div className="div-banner">
            <div className="container h-100">
              {banner}
            </div>
          </div>

          <div className="menu-home">
            <div className="container h-100">
              <div className="text-center voce-sx">
                <a className="link" onClick={()=>{this.showGlossario()}}><img src="img/glossario.svg" className="bottone-sx btn-glossario" /></a>
                <a className="link" data-toggle="modal" data-target="#modal_suggerimenti"><img src="img/suggerimento.svg" className="btn-suggerimento" /></a>
              </div>
            </div>
          </div>

          <div className="row aggiornamenti">
            <div className="col-sm-12 text-center">
              <strong>AGGIORNAMENTI</strong>
            </div>
          </div>

          <div className="news">
            <div className="container container-1024 h-100">

              <div className="row">
                <div className="col-sm-12 col-md-4">
                  <div className="row col-12 testo news-1">
                    <div className="top-news-1"></div>
                    <div className="testino" dangerouslySetInnerHTML={createMarkup(news[0].testo)} />
                    {news[0].id_lemma ? <a className="link" onClick={()=>this.showLemmaFromNews(news[0].id_lemma)}><img src="img/entra.svg" width="90" /></a> : ''}
                  </div>
                </div>
                <div className="col-sm-12 col-md-4">
                  <div className="row col-12 testo news-2">
                    <div className="top-news-2"></div>
                    <div className="testino" dangerouslySetInnerHTML={createMarkup(news[1].testo)} />
                    {news[1].id_lemma ? <div><a className="link" onClick={()=>this.showLemmaFromNews(news[1].id_lemma)}><img src="img/entra.svg" width="90" /></a></div> : ''}
                  </div>
                </div>
                <div className="col-sm-12 col-md-4">
                  <div className="row col-12 testo news-3">
                    <div className="top-news-3"></div>
                    <div className="testino" dangerouslySetInnerHTML={createMarkup(news[2].testo)} />
                    {news[2].id_lemma ? <div><a className="link" onClick={()=>this.showLemmaFromNews(news[2].id_lemma)}><img src="img/entra.svg" width="90" /></a></div> : ''}
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>

    if (this.state.pagina==="glossario")
      pagina =
        <div className="container container-1024 h-100">
          <Guida />
          <div className="row glossario">
            <div className="col-sm-12 col-md-6">
              {/*
              <div className="row col-12 filtro">
                <div className="custom-control custom-checkbox custom-checkbox-height">
                  <input type="checkbox" className="custom-control-input" id="chkbx" onChange={this.filterBookmarks} />
                  <label className="custom-control-label" htmlFor="chkbx">Mostra i preferiti <img src="img/preferito_on.svg" width="20px" alt="*" /></label>
                </div>
              </div>
              */}
              <div className="row mb-4">
                <div className="input-group">
                  <input id="in-lemma" type="text" className="form-control" placeholder="Cerca lemma..." aria-label="Cerca lemma..." aria-describedby="button-addon2" onChange={this.filterLemma} />
                  <div className="input-group-append">
                    <button className="btn btn-outline-secondary" type="button" id="button-addon2" onClick={()=>{this.resetLemma()}}>{_reset}</button>
                  </div>
                </div>
              </div>
              {/*
              <div className="row">
                <div className="col-12 filtro"><input className="form-control" onChange={this.filterLemma} type="text" placeholder="Cerca lemma..." /></div>
              </div>
              */}
              {/*
              <div className="row col-12 filtro">Categorie</div>
              <div className="row">
                <div className="col-12 filtro">
                  <select className="custom-select" onChange={this.changeCategoria}>
                    <option value='0'>Tutte le categorie</option>
                    {select_categorie}
                  </select>
                </div>
              </div>
              */}
              {this.state.mobile ? <div className="mt-3">Selezione lemma</div> : ''}
              <div className="row">
                <div className="col-12 lemmi" id="div-lemmi">{html_lemmi}</div>
              </div>
            </div>
            <div className="col-sm-12 col-md-6" id="div-scheda">
              {this.state.mobile ? <div className="mt-3">Definizione lemma</div> : ''}
              {scheda_sopra}
              {this.state.mobile ? <div className="mt-3">Altre informazioni</div> : ''}
              {scheda_sotto}
            </div>
          </div>
          <div className="row">
            <div className="col-12 text-center">
              <a className="link" data-toggle="modal" data-target="#modal_suggerimenti"><img src="img/suggerimento_in.svg" width="270" /></a>
            </div>
          </div>
        </div>

    if (this.state.pagina==="approfondimenti")
      pagina =
        <div className="container container-1024 h-100">
          <GuidaApprofondimenti />
          <div className="row">
            <div className="col-12">
              <h6>PUBBLICATI</h6>
              <table className="table table-striped"><tbody>{html_approfondimenti_pubblicati}</tbody></table>
              <p>&nbsp;</p>
              {html_approfondimenti_da_pubblicare.length!==0 ? <div><h6>DI PROSSIMA PUBBLICAZIONE</h6><table className="table table-striped"><tbody>{html_approfondimenti_da_pubblicare}</tbody></table></div> : ''}
            </div>
          </div>
        </div>

    let modal_razionale =
      <div className="modal fade" id="modal_razionale" tabIndex="-1" role="dialog" aria-labelledby="modal_razionaleLabel" aria-hidden="true">
        <div className="modal-dialog modal-xl" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="modal_razionaleLabel">Razionale</h5>
              <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <Razionale />
            </div>
            <div className="modal-footer">
              <button type="button" className="btn btn-secondary" data-dismiss="modal">Chiudi</button>
            </div>
          </div>
        </div>
      </div>

    /*
    let modal_autore =
      <div className="modal fade" id="modal_autore" tabIndex="-1" role="dialog" aria-labelledby="modal_autoreLabel" aria-hidden="true">
        <div className="modal-dialog modal-xl" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="modal_autoreLabel">Autore</h5>
              <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <Autore />
            </div>
            <div className="modal-footer">
              <button type="button" className="btn btn-secondary" data-dismiss="modal">Chiudi</button>
            </div>
          </div>
        </div>
      </div>
    */

    let modal_credits =
      <div className="modal fade" id="modal_credits" tabIndex="-1" role="dialog" aria-labelledby="modal_creditsLabel" aria-hidden="true">
        <div className="modal-dialog modal-xl" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="modal_creditsLabel">Credits</h5>
              <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <Credits />
            </div>
            <div className="modal-footer">
              <button type="button" className="btn btn-secondary" data-dismiss="modal">Chiudi</button>
            </div>
          </div>
        </div>
      </div>

    let modal_pillola =
      <div className="modal fade" id="modal_pillola" tabIndex="-1" role="dialog" aria-labelledby="modal_pillolaLabel" aria-hidden="true">
        <div className="modal-dialog modal-xl" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="modal_pillolaLabel">{this.state.nome_pillola}</h5>
              <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <div dangerouslySetInnerHTML={createMarkup(this.state.testo_pillola)} />
            </div>
            <div className="modal-footer">
              <button type="button" className="btn btn-secondary" data-dismiss="modal">Chiudi</button>
            </div>
          </div>
        </div>
      </div>

    let modal_approfondimento =
      <div className="modal fade" id="modal_approfondimento" tabIndex="-1" role="dialog" aria-labelledby="modal_approfondimentoLabel" aria-hidden="true">
        <div className="modal-dialog modal-xl" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="modal_approfondimentoLabel">{this.state.nome_approfondimento}</h5>
              <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <div className="embed-responsive embed-responsive-16by9">
                {this.state.video}
              </div>
            </div>
            <div className="modal-footer">
              <a className="btn btn-primary" href={"media/"+this.state.slides} target="_blank">Scarica slides</a>
              <button type="button" className="btn btn-secondary" data-dismiss="modal">Chiudi</button>
            </div>
          </div>
        </div>
      </div>

    let modal_suggerimenti =
      <div className="modal fade" id="modal_suggerimenti" tabIndex="-1" role="dialog" aria-labelledby="modal_suggerimentiLabel" aria-hidden="true">
        <div className="modal-dialog modal-xl" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="modal_suggerimentiLabel">Invia un suggerimento</h5>
              <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <div className="row">
                <div className="col-12">
                  Tutti coloro che vogliono contribuire a questi aggiornamenti/modifiche del glossario possono farlo utilizzando questo strumento. Il messaggio, per essere preso in considerazione, deve contenere un preciso suggerimento e, in particolare, deve chiedere di:
                  <ul>
                  <li>modificare il significato/definizione di un termine</li>
                  <li>aggiungere a un termine un ulteriore significato/definizione</li>
                  <li>introdurre un nuovo termine (con relativo significato/definizione)</li>
                  <li>stabilire una relazione tra due termini (es. sinonimi, ovvero uno sottotipo dell’altro)</li>
                  </ul>
                  Utile (anche se non indispensabile) un riferimento bibliografico.
                </div>
              </div>
              <br />
              <Suggerimenti />
            </div>
            <div className="modal-footer">
              <button type="button" className="btn btn-secondary" data-dismiss="modal">Chiudi</button>
            </div>
          </div>
        </div>
      </div>

    let modal_policy =
      <div className="modal fade" id="modal_policy" tabIndex="-1" role="dialog" aria-labelledby="modal_policyLabel" aria-hidden="true">
        <div className="modal-dialog modal-xl" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="modal_policyLabel"></h5>
              <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <div className="embed-responsive embed-responsive-16by9">
                <iframe title="cookiepolicy" frameBorder="0" src="https://www.accmed.org/cookiepolicy.html"></iframe>
              </div>
            </div>
            <div className="modal-footer">
              <button type="button" className="btn btn-secondary" data-dismiss="modal">Chiudi</button>
            </div>
          </div>
        </div>
      </div>

    let modal_guida =
      <div className="modal fade" id="modal_guida" tabIndex="-1" role="dialog" aria-labelledby="modal_guidaLabel" aria-hidden="true">
        <div className="modal-dialog modal-xl" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="modal_guidaLabel">Guida all'uso</h5>
              <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <strong>COME CERCARE UN VOCABOLO</strong>
              <p>Inserisci nel campo <strong>Lemma</strong> la parola (in lingua italiana o inglese), o parte di essa, della quale vuoi trovare la definizione. Nell'area sottostante viene mostrato il risultato della ricerca.<br />
              {/*Filtra la lista di definizioni per <strong>categoria</strong> di appartenenza o crea una selezione di lemmi personalizzata, utilizzando la funzione <strong>Aggiungi ai preferiti</strong>.*/}
              </p>
              <strong>COME INVIARE UN SUGGERIMENTO</strong>
              <p>Se ritieni che qualche definizione non sia completa o se vuoi segnalare all'autore una nuova definizione, puoi utilizzare lo strumento <a className="a-strong" href="#" data-toggle="modal" data-target="#modal_suggerimenti"><strong>Invia un suggerimento.</strong></a></p>
            </div>
            <div className="modal-footer">
              <button type="button" className="btn btn-secondary" data-dismiss="modal">Chiudi</button>
            </div>
          </div>
        </div>
      </div>

    return (

    <React.Fragment>

      <div id="app">

        <div>

          <nav className="navbar navbar-expand-lg navbar-dark bg-dark bg-primary">
            <div className="container container-1024" style={{"paddingLeft":"20px"}}>
              <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                <span className="navbar-toggler-icon"></span>
              </button>
              <div className="collapse navbar-collapse" id="navbarSupportedContent">
                <ul className="navbar-nav mr-auto">
                  <li className="nav-item">
                    <a className="nav-link" href="#" data-toggle="modal" data-target="#modal_razionale">RAZIONALE</a>
                  </li>
                  {/*
                  <li className="nav-item">
                    <a className="nav-link" href="#" data-toggle="modal" data-target="#modal_autore">AUTORE</a>
                  </li>
                  */}
                  <li className="nav-item">
                    <a className="nav-link" href="#" data-toggle="modal" data-target="#modal_guida">GUIDA</a>
                  </li>
                  <li className="nav-item">
                    <a className="nav-link" href="#" data-toggle="modal" data-target="#modal_credits">CREDITS</a>
                  </li>
                  {/*
                  <li className="nav-item dropdown voci-dx">
                    <a className="nav-link dropdown-toggle" href="#" id="navbarDropdown1" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                      PILLOLE
                    </a>
                    <div className="dropdown-menu" aria-labelledby="navbarDropdown">
                      {menu_pillole}
                    </div>
                  </li>
                  */}
                  {/*
                  <li className="nav-item">
                    {
                      this.state.pagina==="approfondimenti"
                      ? <a className="nav-link" href="#" onClick={()=>{$("#navbarSupportedContent").removeClass("show"); this.setState({pagina:'glossario'})}}>GLOSSARIO</a>
                      : <a className="nav-link" href="#" onClick={()=>{$("#navbarSupportedContent").removeClass("show"); this.setState({pagina:'approfondimenti'})}}>APPROFONDIMENTI</a>
                    }
                  </li>
                  */}
                </ul>
              </div>
            </div>
          </nav>

        </div>

        <div className="page-wrap">{pagina}</div>

      </div>

      {modal_razionale}
      {/*modal_autore*/}
      {modal_credits}
      {modal_pillola}
      {modal_approfondimento}
      {modal_guida}
      {modal_suggerimenti}
      {modal_policy}

    </React.Fragment>
    );
  }
}

class Razionale extends Component {

  render() {
    return (
      <div className="row">
        <div className="col-12 ridotto">
          <p>La ricerca clinica ha un suo linguaggio, quasi uno slang, che utilizza vocaboli presi dalla statistica, dall’epidemiologia, dalla medicina/biologia, dall’informatica e da vari altri settori come le scienze amministrative, l’organizzazione aziendale e altri.</p>
          <p><strong>Come in tutti campi, anche in questo una buona conoscenza del linguaggio è indispensabile per dominare la materia o almeno per capirne gli sviluppi e interpretarne i risultati.</strong></p>
          <p>Credo che invece, nella miriade di competenze e professionalità che ruotano intorno alla ricerca clinica, molti abbiano spesso difficoltà a capire il significato di termini e concetti anche abbastanza semplici, e che la lettura di un manuale sia spesso (giustamente) considerata lunga, noiosa e poco efficiente.</p>
          <p>Un dizionario, o meglio, un glossario dedicato alla terminologia della ricerca clinica, è sicuramente più facile da consultare e anche più efficiente, perché permette di trovare rapidamente la risposta che si cerca. Ne esistono molti, alcuni di ottima qualità; per quanto ne so, il più datato è quello contenuto nel manuale “Clinical Trials” di Curt Meinert (Oxford University Press, 1986), manuale che, a dispetto dell’impostazione da ricettario per apprendisti cuochi, è uno scrigno pieno di preziose informazioni e consigli pratici, suggerimenti, esempi, risorse per consultazione, supporti mnemonici, tutti centrati e utilissimi, tra cui, appunto, un ricco glossario.</p>
          <p>D’altra parte, contrariamente a quanto si potrebbe credere, la ricerca clinica e il suo linguaggio sono in continua evoluzione. Ad esempio, termini come “non-inferiority” o “futility” non esistevano ancora 20 anni fa, così come non esistevano i concetti e i metodi a cui fanno riferimento. Questo crea un problema alla forma cartacea, che è penalizzata dall’impossibilità di aggiornare i suoi contenuti. Un secondo problema, altrettanto grave, è quello della difficoltà di consultazione legata alla scarsa portabilità, per cui l’informazione spesso non è disponibile quando se ne avrebbe bisogno.</p>
          <p>Questo glossario, rappresenta il tentativo di superare questi problemi, sfruttando i vantaggi legati al formato elettronico: innanzitutto la portabilità, che lo rende rapidamente consultabile in qualsiasi situazione. In secondo luogo la possibilità di aggiornamenti periodici a costi pressoché nulli.</p>
          <p>Per questo secondo aspetto, però, abbiamo pensato a qualcosa di maggiormente innovativo: dal momento che sul significato di molti termini e concetti non esiste un accordo completo tra gli esperti o ci sono ambiguità in parte irrisolte, sicuramente molti significati/definizioni riportati in questa prima versione del Glossario daranno luogo a critiche o saranno giudicati incompleti. Inoltre, ci saranno sicuramente importanti termini e concetti dei quali ci siamo dimenticati.</p>
          <p>Il formato elettronico consentirà però di rimediare a errori od omissioni e di aggiornarne continuamente i contenuti. Tutti coloro che vorranno contribuire a questi aggiornamenti/modifiche del glossario potranno farlo utilizzando lo strumento Suggerimenti disponibile nella pagina principale di GRASP. Il messaggio, per essere preso in considerazione, dovrà contenere un preciso suggerimento e, in particolare, dovrà chiedere di:</p>
          <ul>
            <li>modificare il significato/definizione di un termine</li>
            <li>aggiungere a un termine un ulteriore significato/definizione</li>
            <li>introdurre un nuovo termine (con relativo significato/definizione)</li>
            <li>stabilire una relazione tra due termini (es. sinonimi, ovvero uno sottotipo dell’altro)</li>
          </ul>
          <p>Utile (anche se se non indispensabile) un riferimento bibliografico.</p>
          <p>Tutti i suggerimenti verranno esaminati personalmente dal sottoscritto, che deciderà insindacabilmente quali adottare, inserendoli nel Glossario. Come doveroso riconoscimento, il nome/i e l’afferenza dell’autore/i del suggerimento saranno acclusi al testo.</p>
          <p>In questo modo, ci auguriamo che il Glossario diventi uno strumento dinamico, in costante evoluzione e sempre più rappresentativo di un patrimonio di conoscenze comuni, slegato quindi dalle competenze e dai preconcetti di chi ne ha ideato la prima versione, che si riserva il ruolo di moderatore e guardiano del tenore scientifico dei contenuti.</p>
        </div>
      </div>
    )
  }
}
/*
class Autore extends Component {

  render() {
    return (

      <React.Fragment>
        <div className="row">
          <div className="col-12">
            <strong>Paolo Bruzzi</strong><br />Epidemiologo, GENOVA
          </div>
        </div>
        <div className="row">
          <div className="col-sm-12 col-md-3">
            <img className="img-fluid" src="img/bruzzi.jpg" alt="Paolo Bruzzi" />
          </div>
          <div className="col-sm-12 col-md-9 ridotto">
            Autore di più di 350 pubblicazioni su riviste censite da PubMed per un IF totale superiore a 1.500 (H Index = 74 (PoP), =65 (WoS) 66 (Scopus)).<br />
            Titolare nel corso degli anni di vari finanziamenti da AIRC, Ministero della Salute, enti privati e aziende. Già Professore a Contratto dell’Università di Genova e titolare dell’insegnamento di Statistica Medica del Corso di Laurea in Biotecnologie e della Scuola di Specializzazione in Malattie Infettive e del Master in Epidemiologia dell’Associazione Italiana di Epidemiologia.<br />
            Docente in vari Master universitari, e in innumerevoli corsi, su tematiche relative alla Metodologia della Ricerca Clinica.
          </div>
        </div>
      </React.Fragment>
    )
  }
}
*/
class Credits extends Component {

  render() {
    return (
      <div className="row">
        <div className="col-12 ridotto">
          <p><strong>Coordinamento scientifico</strong></p>
          Accademia Nazionale di Medicina<br />
          Via M. Piaggio 17/6 - 16122 Genova GE<br />
          T. +39 010.837.94.1 | F. +39 010.837.94.260<br />
          <a href="https://www.accmed.org" target="_blank" rel="noopener noreferrer">https://www.accmed.org</a>, <a href="mailto:info.anm@accmed.org">info.anm@accmed.org</a><br />
          Direttore generale: Stefania Ledda<br /><br />
          <p><strong>Sviluppo applicazione</strong></p>
          Forum Service S.r.l<br />
          Via M. Piaggio 17/7 - 16122 Genova GE<br />
          T. +39 010.837.94.1 | F. +39 010.837.94.261<br />
          <a href="https://www.forumservice.net" target="_blank" rel="noopener noreferrer">https://www.forumservice.net</a>, <a href="mailto:info.fs@forumservice.net">info.fs@forumservice.net</a><br /><br />
          <p><em>Copyright © {new Date().getFullYear()} Accademia Nazionale di Medicina. - Tutti i diritti riservati. Gli autori, e tutti quanti hanno preso parte alla realizzazione dell’opera non possono essere ritenuti in ogni caso responsabili degli errori concettuali derivanti dall’evolversi del pensiero clinico e neppure di quelli materiali in cui possono essere incorsi, nonostante tutto l’impegno dedicato a evitarli. L’autorizzazione alla riproduzione completa o in parte dei contenuti di questa applicazione deve essere richiesta.</em></p>

          {
          /*
          <p>&nbsp;</p>
          <p><a href="https://www.daiichi-sankyo.it/" target="_blank" rel="noopener noreferrer"><img src="img/sponsor.svg" height="160" /></a></p>
          */
          }

        </div>
      </div>
    )
  }
}

class Guida extends Component {

  render() {
    return (
      <div className="row">
        <div className="col-12 ridotto--- aiutino">
          Inserisci nel campo <strong>Lemma</strong> la parola (in lingua italiana o inglese), o parte di essa, della quale vuoi trovare la definizione. Nell'area sottostante viene mostrato il risultato della ricerca.
          {/*Filtra la lista di definizioni per <strong>categoria</strong> di appartenenza o crea una selezione di lemmi personalizzata, utilizzando la funzione <strong>Aggiungi ai preferiti</strong>.*/}
        </div>
      </div>
    )
  }
}

class GuidaApprofondimenti extends Component {

  render() {
    return (
      <div className="row">
        <div className="col-12 aiutino">
          In questa pagina trovi una raccolta di approfondimenti che, anche grazie al contributo di esperti esterni, illustra il significato di alcuni termini o alcuni concetti legati al linguaggio della ricerca clinica. Gli stessi approfondimenti, quando necessario, sono richiamati all'interno dei lemmi presenti nel glossario.
        </div>
      </div>
    )
  }
}

class Suggerimenti extends Component {

  sendEmail = (e) => {

    e.preventDefault()
    e.stopPropagation()

    let data = $("#the-form").serialize();
    $('#the-result').html('<div className="loading"><p><img src="img/loader.gif" width="100" height="100" alt="loader"></p></div>');
    $.ajax({
    		type: "POST",
    		url:  "_services/email.php",
    		data: data
    	})
    	.done(function(sHtml) {
    		if (sHtml) $("#the-result").html("Attenzione, il messaggio non è stato inviato! Forse hai dimenticato di cliccare il reCAPTCHA?"); else $("#the-result").html("Messaggio inviato correttamente!");
    	})
    	.fail(function(jqXHR, textStatus) {
    		$("#the-result").html("Ops, qualcosa è andato storto...");
    	});

  }

  render() {

    return (

      <React.Fragment>

      <form id="the-form" onSubmit={this.sendEmail}>
        <div className="row">
          <div className="col-12">
            <input id="email" name="email" className="form-control" type="email" required="required" placeholder="La tua email" /><br />
          </div>
          <div className="col-12">
            <input id="nome" name="nome" className="form-control" type="text" required="required" placeholder="Il tuo nome" /><br />
          </div>
          <div className="col-12">
            <textarea id="messaggio" name="messaggio" className="form-control" rows="5" required="required" placeholder="Il tuo messaggio"></textarea><br />
          </div>
          <div className="col-12 recaptcha">Sei umano? Clicca qui sotto, grazie!</div>
          <div className="col-12 recaptcha"><ReCAPTCHA sitekey="6LeZ5wUAAAAAAEFuPxN1nma9lrIo57wi4XVWlVVT" /></div>
          <div className="col-12 recaptcha"><button className="btn btn-primary email" type="submit">Invia</button></div>
          <div className="col-12" id="the-result"></div>
        </div>
      </form>

      </React.Fragment>

    )
  }
}

function bannerTimer() {
  n_banner = n_banner===3 ? 1 : n_banner+1
  var mobile = window.screen.width < 768 ? true : false;
  if (mobile)
    $("#banner").fadeOut(2000, function() { $("#banner").html('<img src="img/banner-'+n_banner+'-mobile.svg" />').fadeIn(2000) } )
  else
    $("#banner").fadeOut(2000, function() { $("#banner").html('<img src="img/banner-'+n_banner+'.svg" />').fadeIn(2000) } )
}

function stampaScheda() {

    var content = document.getElementById("lemma").innerHTML;
    var mywindow = window.open('', 'Print', 'height=600,width=800');

    mywindow.document.write('<html><head><title>Stampa</title>');
    mywindow.document.write('</head><body >');
    mywindow.document.write(content);
    mywindow.document.write('</body></html>');

    mywindow.document.close();
    mywindow.focus()
    mywindow.print();
    mywindow.close();
    return true;
}

function createMarkup(html) { return {__html: html}; };

export default App;
